import {Component, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {UserDetail} from "../../model/user-detail";
import {UsersDetailFilter} from "@model";

@Component({
  selector: 'user-list-modal',
  templateUrl: './user-list-modal.component.html',
  styleUrls: ['./user-list-modal.component.scss']
})
export class UserListModalComponent {
  @Input() title: string | undefined;
  @Input() users: UserDetail[] | undefined;
  @Input() filteredUsers: UserDetail[] | undefined;
  @Input() showLoadMore: boolean = false;
  @Input() filterExternal: boolean = false;
  @Input() selectedUser: UserDetail | undefined;
  @Input() checkboxEnabled: boolean = false;
  @Output() filterChanged = new EventEmitter<UsersDetailFilter>();
  @Output() loadMoreTriggered = new EventEmitter<void>();


  @ViewChild('tableContainer') tableContainer: ElementRef | undefined;


  constructor(public activeModal: NgbActiveModal) {
  }

  trackById(index: number, user: any): number {
    return user.id;
  }


  userSelected(user:UserDetail) {
    this.selectedUser = user;
    this.activeModal.close(user);
  }


  loadMore() {
    this.loadMoreTriggered.emit();
  }

  scrollToBottom(): void {
    if (this.tableContainer) {
      const container = this.tableContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    }
  }


  onDismissClick(): void {
    /// https://github.com/ng-bootstrap/ng-bootstrap/issues/3721
    this.activeModal.dismiss();
  }

  handleSearchInput(value: string | Event): void {
    let input: string;

    if (typeof value === 'string') {
      input = value.trim();
    } else {
      input = ((value.target as HTMLInputElement).value ?? "").trim();
    }

    if (this.filterExternal) {
      const filterValue = input.length > 0 ? input : undefined;
      this.filterChanged.emit(new UsersDetailFilter(filterValue));
    } else {
      this.filterInternal(input);
    }
  }


  filterInternal(input: string): void {
    if (input.length > 0) {
      this.filteredUsers = this.users?.filter((user: UserDetail) => {
        return user.firstname?.includes(input) ||
          user.lastname?.includes(input) ||
          user.phoneNumber?.includes(input) ||
          user.email?.includes(input);
      });
    } else {
      this.filteredUsers = this.users;
    }
  }
}

